module.exports = __webpack_public_path__ + "img/progress.157e782c.png";